import React from 'react'
import CollapsedPaper from './CollapsedPaper'
import BatteryPowerManagementTable from './BatteryPowerManagementTable'
import { useBatteryPowerManagementList } from 'src/Libs/batteries/hooks/use-batteries'
import { Loading } from '@e3dc-react/shell/Elements/Loading'
import { ErrorMessage } from '@e3dc-react/shell/Elements/Error'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

type BatteryPowerManagementProps = {
  storageId?: string
}

/**
 * Component that holds the battery power management tile for the hardware component section of system details.
 */
const BatteryPowerManagement: React.FC<BatteryPowerManagementProps> = ({ storageId }) => {
  const [bpm, isLoading, isError] = useBatteryPowerManagementList(storageId)
  const { t } = useCustomTranslation()

  return (
    <CollapsedPaper title={t('system-details.components.bpm.title')}>
      {isError ? (
        <ErrorMessage title={t('system-details.components.bpm.error')} />
      ) : isLoading ? (
        <Loading />
      ) : (
        <BatteryPowerManagementTable bpm={bpm ?? []} />
      )}
    </CollapsedPaper>
  )
}

export default BatteryPowerManagement
